import { setEnum } from '../../helpers/enums';

/**
 * setSellerFilterBarModifiers
 * @param {object} state
 * @param {string} selected
 * @returns {object} newState of 'filters' based on UI tab selection. Note: WebApi expects values as Capitalcase Enum;
 */
const setSellerFilterBarModifiers = (state, selected) => {
    const newState = { ...state };
    if (selected === 'Valj') {
        return newState;
    }

    if (newState.modifiers.sellerFilters) {
        Object.keys(newState.modifiers.sellerFilters).forEach(key => {
            newState.modifiers.sellerFilters[key] = setEnum('All');
        });
    }

    if (newState.modifiers.buyerFilters) {
        Object.keys(newState.modifiers.buyerFilters).forEach(key => {
            newState.modifiers.buyerFilters[key] = setEnum('All');
        });
    }

    switch (selected) {
        case 'CombinedShipping':
            newState.modifiers.sellerFilters.combinedShippingPriceRequested = setEnum(
                true
            );
            newState.modifiers.sellerFilters.hidden = setEnum(false);
            break;
        case 'SellerNoFeedback':
            newState.modifiers.sellerFilters.paid = setEnum(true);
            newState.modifiers.sellerFilters.shipped = setEnum(true);
            newState.modifiers.sellerFilters.feedbackLeft = setEnum(false);
            newState.modifiers.sellerFilters.hidden = setEnum(false);
            break;
        case 'BuyerNoFeedback':
            newState.modifiers.buyerFilters.feedbackLeft = setEnum(false);
            newState.modifiers.buyerFilters.paid = setEnum(true);
            newState.modifiers.buyerFilters.hidden = setEnum(false);
            break;
        case 'SellerNotPaid':
            newState.modifiers.sellerFilters.paid = setEnum(false);
            newState.modifiers.sellerFilters.shipped = setEnum(false);
            newState.modifiers.sellerFilters.hidden = setEnum(false);
            break;
        case 'BuyerNotPaid':
            newState.modifiers.buyerFilters.paid = setEnum(false);
            newState.modifiers.buyerFilters.hidden = setEnum(false);
            break;
        case 'NotSent':
            newState.modifiers.sellerFilters.paid = setEnum(true);
            newState.modifiers.sellerFilters.shipped = setEnum(false);
            newState.modifiers.sellerFilters.hidden = setEnum(false);
            break;
        case 'AllSold':
        case 'AllUnsold':
            newState.modifiers.sellerFilters.hidden = setEnum(false);
            break;
        case 'SellerHidden':
            newState.modifiers.sellerFilters.hidden = setEnum(true);
            break;
        case 'BuyerHidden':
            newState.modifiers.buyerFilters.hidden = setEnum(true);
            break;
        case 'BuyerNotHidden':
            newState.modifiers.buyerFilters.hidden = setEnum(false);
            break;
        case 'AllPurchases':
            newState.modifiers.buyerFilters.hidden = setEnum(false);
            break;
        case 'AllBids':
            newState.modifiers.hasBids = setEnum('All');
            break;
        case 'HasBids':
            newState.modifiers.hasBids = setEnum(true);
            break;
        case 'NoBids':
            newState.modifiers.hasBids = setEnum(false);
            break;
        case 'ItemsLostNotHidden':
            newState.modifiers.buyerFilters.hidden = setEnum(false);
            break;
        case 'ItemsLostHidden':
            newState.modifiers.buyerFilters.hidden = setEnum(true);
            break;
        default:
            break;
    }
    return newState;
};

export default {
    setSellerFilterBarModifiers
};
